export { default as MarketingExpenseSlot } from './MarketingExpenseSlot';
